import CustomButton from "components/Atoms/CustomButton"
import Divider from "components/Atoms/Divider"
import React from "react"
import styles from "./style.module.scss"
type FormCardProps = {
  children?: React.ReactNode
  onRemove?: () => void
  title?: React.ReactNode
}

const FormCard = ({ children, onRemove, title }: FormCardProps) => {
  return (
    <div className={styles.formCard}>
      <header className={styles.formCardHeader}>
        <h6 className="m-0">{title}</h6>
        {onRemove && (
          <CustomButton
            intent="danger"
            icon="trash"
            minimal
            onClick={onRemove}
          />
        )}
      </header>
      <Divider className="mt-2 mb-3" />
      <section className={styles.formCardContent}>{children}</section>
    </div>
  )
}

export default FormCard
